import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const BaseIcon: React.FC<SvgIconProps> = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="24" height="24" viewBox="4 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#0052FF"
        d="M11.986 20C16.412 20 20 16.418 20 12s-3.588-8-8.014-8A8.01 8.01 0 0 0 4 11.328h10.593v1.345H4C4.342 16.776 7.787 20 11.986 20"
      />
    </SvgIcon>
  )
}
